"use client";
import { Label } from "../ui/label";
import { Input } from "../ui/input";
import { apiFetch } from "@/lib/ftv-api/api-ftv";
import { ApiError } from "@/lib/ftv-api/api-error";
import { useEffect, useRef, useState } from "react";
import { Button } from "../ui/button";
import { useParams, useRouter } from "next/navigation";

const SearchBrand = ({ search , sizes}) => {
  const { locale } = useParams();
  const [origin, setOrigin] = useState([]);
  const [filteredOrigin, setFilteredOrigin] = useState([]);
  const [showOrigin, setShowOrigin] = useState(false);
  const [loadingOrigin, setLoadingOrigin] = useState(false);
  const [originCountryName, setOriginCountryName] = useState("");
  const [originCountryExt, setOriginCountryExt] = useState("");
  const originRef = useRef();
  const fetchedOnce = useRef(false);
  //destination set value
  const [errorMsg, setErrorMsg] = useState("");
  const [destination, setDestination] = useState([]);
  const [destinationCountry, setDestinationCountry] = useState("");
  const [filteredDestination, setFilteredDestination] = useState([]);
  const [showDestination, setShowDestination] = useState(false);
  const [loadingDestination, setLoadingDestination] = useState(false);
  const [isVisaError,setIsVisaError] = useState('')
  const [visaLoading, setVisaLoading] = useState(false)
  const destRef = useRef(); 
   const router = useRouter();

 

  const originClick = async () => {
    setIsVisaError('')
    if (!locale) return;
    setShowOrigin(true);    

    try {
      setLoadingOrigin(true);
      const res = await apiFetch(`/api/${locale}/origin-country`, {
        cache: "no-store",
      });

      const data = Array.isArray(res.origin_country) ? res.origin_country : [];

      setOrigin(data);
      console.log(data)
      setFilteredOrigin(data);
    } catch (error) {
      if (error instanceof ApiError) {
        console.error(error.status, error.message);
      }
      setOrigin([]);
      setFilteredOrigin([]);
    } finally {
      setLoadingOrigin(false);
    }
  };

  const originInputChange = (e) => {
    const val = e.target.value.toLowerCase().trim();
    setOriginCountryName(e.target.value);

    if (!val) {
      setFilteredOrigin(origin);
      return;
    }
    const filterData = origin.filter((el) =>
      el.name.toLowerCase().includes(val)
    );
    setFilteredOrigin(filterData);
  };

  const originCountryClick = async (country) => {
    if (!country?.extention || !country?.name) {
      setIsVisaError("Invalid country selection");
      return;
    }

    setIsVisaError("");
    setOriginCountryName(country.name);
    setOriginCountryExt(country.extention);
    setShowOrigin(false);

    const originCountry = encodeURIComponent(country.name.toLowerCase());
    const ext = country.extention.toLowerCase();

    setShowDestination(true);
    setDestination([]);
    setFilteredDestination([]);
    setDestinationCountry("")

    try {
      setLoadingDestination(true);
      const res = await apiFetch(
        `/api/${ext}/origin-country/${originCountry}`,
        { cache: "no-store" }
      );

      const data = Array.isArray(res.destination_country)
        ? res.destination_country
        : [];

      setDestination(data);
      setFilteredDestination(data);
    } catch (error) {
      if (error instanceof ApiError) {
        setErrorMsg(error.message || "Failed to fetch destination");
      } else {
        setErrorMsg("Something went wrong");
      }
    } finally {
      setLoadingDestination(false);
    }
  };

  const destinationCountryClick = (country) => {
    if (!country?.name) {
      setIsVisaError("Invalid destination country selection");
      return;
    }
    setDestinationCountry(country.name);
    setShowDestination(false);
  };
  const destinationChange = (e) => {
    const val = e.target.value.toLowerCase().trim();
    setDestinationCountry(e.target.value);

    if (!val) {
      setFilteredDestination(destination);
      return;
    }
    const filterData = destination.filter((el) =>
      el.name.toLowerCase().includes(val)
    );
    setFilteredDestination(filterData);
  };
  const desInputClick = (e) => {
    const value = e.target.value;
    if(!value){
      setIsVisaError('Please select origin country first')
      return;
    }
    setIsVisaError('');
    setShowDestination(true);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      const target = e.target;

      // Origin dropdown
      if (originRef.current && !originRef.current.contains(target)) {
        setShowOrigin(false);
      }
      // Destination dropdown
      if (destRef.current && !destRef.current.contains(target)) {
        setShowDestination(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

const getVisa = async () => {
  const ext = originCountryExt;
  const destCountry = destinationCountry;
  setVisaLoading(true);
  setIsVisaError("");
  // Validation
  if (!ext) {
    setIsVisaError("Please select origin country");
    setVisaLoading(false);
    return;
  }
  if (!destCountry) {
    setIsVisaError("Please select destination country");
    setVisaLoading(false);
    return;
  }

const normalizedCountry = destCountry.toLowerCase().trim();
  const destinationSlug =
    normalizedCountry.replace(/\s+/g, "-") + "-visa";

  const destinationParam = encodeURIComponent(normalizedCountry);

  try {
    await apiFetch(
      `/api/${ext}/international-visa/${destinationParam}`,
      { cache: "no-store" }
    );
    router.push(`/${ext}/${destinationSlug}`);
  } catch (error) {
    if (error instanceof ApiError) {
      setIsVisaError("Visa not available, try another country");
    } else {
      setIsVisaError("Visa not found");
    }
  } finally {
    setVisaLoading(false);
  }
};


  return (
    <>
     <span className={`${sizes ? 'w-full text-xs text-rose-500' : 'w-1/2 text-red-600 pt-3 text-sm'} z-40 absolute top-0 left-auto text-center  `}>{isVisaError}</span>
    <div className="w-full flex gap-2">
      <div className="w-5/12 ftv-field pb-1 relative" ref={originRef}>
        <Label
          htmlFor={`origin${search}`}
          className="pt-1 px-2 mb-2 font-poppins text-xs text-primary/70 font-normal"
        >
          I am a citizen of
        </Label>

        <Input
          id={`origin${search}`}
          className="border-transparent"
          value={originCountryName}
          onClick={originClick}
          onChange={originInputChange}
        />

        {showOrigin && (
          <div className="absolute top-full left-0 w-60 z-30 bg-white dark:bg-black border border-gray-300 dark:border-gray-900 shadow-md">
            {loadingOrigin ? (
              <p className="px-4 py-2 text-xs text-gray-400">Loading…</p>
            ) : filteredOrigin.length > 0 ? (
              <ul className="max-h-60 overflow-y-auto">
                {filteredOrigin.map((country, i) => (
                  <li
                    key={i}
                    onClick={() => originCountryClick(country)}
                    className="px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800"
                  >
                    {country.name}
                  </li>
                ))}
              </ul>
            ) : (
              ""
            )}
          </div>
        )}
      </div>
      <div className="w-5/12 ftv-field pb-1" ref={destRef}>
        <Label
          htmlFor={`destination${search}`}
          className={"pt-1 px-2 mb-2 font-poppins text-xs text-primary/70 font-normal"}
        >
          Planning to visit
        </Label>
        <Input
           id={`destination${search}`}
          className={"border-transparent"}
          value={destinationCountry}
          onChange={destinationChange}
          onClick={desInputClick}
        />
        {showDestination && (
          <div className="absolute top-full left-0 w-60 z-30 bg-white dark:bg-black border border-gray-300 dark:border-gray-900 shadow-md">
            {loadingDestination ? (
              <p className="px-4 py-2 text-xs text-gray-400">Loading…</p>
            ) : filteredDestination.length > 0 ? (
              <ul className="max-h-60 overflow-y-auto">
                {filteredDestination.map((country, i) => (
                  <li
                    key={i}
                    onClick={() => destinationCountryClick(country)}
                    className="px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800"
                  >
                    {country.name}
                  </li>
                ))}
              </ul>
            ) : (
              <p className="px-4 py-2 text-xs text-gray-400">
                Destination country not available
              </p>
            )}
          </div>
        )}
      </div>
      <div className="md:w-40 w-30">
        <Button
          className={
            "bg-chart-4 hover:bg-chart-5 px-6 py-10 rounded text-lg uppercase text-gray-800 cursor-pointer dark:bg-chart-4 dark:hover:bg-chart-5 w-full font-geistSans"
          }
          onClick={getVisa}
        >
          {visaLoading ? <span className="capitalize text-sm">Please Wait...</span> : 'Go'}
        </Button>
      </div>
    </div>
    </>
  );
};

export default SearchBrand;
